import API from "@/services/api/api";

// Who can hold a case: Ekspertiza, or one of the external lawyers. The list
// rarely changes, so it is fetched once per page load and shared.
let pending = null;

export function loadNosioci() {
  if (!pending) {
    pending = API.Generic.all("nosioc")
      .then((res) => res.data.data.results || [])
      .catch((err) => {
        pending = null;
        throw err;
      });
  }
  return pending;
}

// Ekspertiza: the first entry that is not a lawyer.
export function defaultNosioc(list) {
  return (list || []).find((n) => !n.advokat) || (list || [])[0] || null;
}
